export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34')
];

export const server_loads = [0,3];

export const dictionary = {
		"/focused-dialog/cancel/package": [~5,[2,3]],
		"/focused-dialog/cancel/package/reason": [~6,[2,3]],
		"/focused-dialog/cancel/package/summary": [~7,[2,3]],
		"/focused-dialog/error": [8,[2]],
		"/home": [~9],
		"/membership": [~10],
		"/points": [~11],
		"/sheet/achievement/collected": [~13,[4]],
		"/sheet/achievement/collected/error": [14,[4]],
		"/sheet/achievement/collect/success": [~12,[4]],
		"/sheet/achievement/expired": [~15,[4]],
		"/sheet/achievement/instructions": [~16,[4]],
		"/sheet/achievement/sponsored": [~17,[4]],
		"/sheet/achievement/tutorial": [18,[4]],
		"/sheet/achievement/tutorial/second": [19,[4]],
		"/sheet/achievement/tutorial/success": [20,[4]],
		"/sheet/achievement/tutorial/third": [21,[4]],
		"/sheet/cancel": [~22,[4]],
		"/sheet/cancel/exceeds-period": [~23,[4]],
		"/sheet/employee-tutorial": [24,[4]],
		"/sheet/error/unknown": [25,[4]],
		"/sheet/my-benefits": [26,[4]],
		"/sheet/next-points-expiration": [27,[4]],
		"/sheet/prebooked-points": [28,[4]],
		"/sheet/raffle/goodbye": [29,[4]],
		"/sheet/raffle/terms-and-conditions": [30,[4]],
		"/sheet/raffle/welcome": [31,[4]],
		"/sheet/raffle/wheel": [32,[4]],
		"/sheet/terms-and-conditions": [33,[4]],
		"/up-achievements": [~34]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';